import React from 'react';

const clampPercent = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.min(Math.max(numeric, 0), 100);
};

const CardsStatistics = ({
  loading = false,
  items = [],
  loadingCount = 5,
  gridClassName = 'grid grid-cols-2 gap-3 mb-8 md:grid-cols-2 md:gap-6 lg:grid-cols-[160px_repeat(4,minmax(0,1fr))]',
  skeletonClassName = 'rounded-xl border border-line bg-surface p-4 shadow-lg animate-pulse md:p-6',
  skeletonTitleClassName = 'h-4 w-28 bg-surface-2 rounded',
  skeletonValueClassName = 'h-8 w-20 bg-surface-2 rounded mt-3',
  skeletonBarClassName = 'h-2 w-full bg-surface-2 rounded mt-6'
}) => {
  return (
    <div className={gridClassName}>
      {loading ? (
        Array.from({ length: loadingCount }).map((_, index) => (
          <div
            key={`kpi-skeleton-${index}`}
            className={`${items[index]?.layoutClassName || 'aspect-square min-[500px]:aspect-[4/3] sm:aspect-[2/1] lg:aspect-auto'} ${skeletonClassName}`}
          >
            <div className={skeletonTitleClassName}></div>
            <div className={skeletonValueClassName}></div>
            <div className={skeletonBarClassName}></div>
          </div>
        ))
      ) : (
        items.map((item) => (
          <div
            key={item.id || item.title}
            className={`flex flex-col rounded-xl p-4 shadow-lg md:p-6 ${item.layoutClassName || 'aspect-square min-[500px]:aspect-[4/3] sm:aspect-[2/1] lg:aspect-auto'} ${item.containerClassName || ''}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className={`text-sm font-medium ${item.titleClassName || ''}`}>
                  {item.title}
                </p>
                <p className="text-3xl font-bold">{item.value}</p>
              </div>
            </div>
            {item.progressLabel ? (
              <div className="mt-auto pt-4">
                <div className="flex items-center justify-end text-sm">
                  <span>{item.progressValue}</span>
                </div>
                <div
                  className={`w-full rounded-full h-2 mt-1 ${item.progressTrackClassName || 'bg-white/20'}`}
                >
                  <div
                    className={`rounded-full h-2 transition-all duration-300 ${item.progressBarClassName || 'bg-white'}`}
                    style={{ width: `${clampPercent(item.progress)}%` }}
                  ></div>
                </div>
              </div>
            ) : null}
          </div>
        ))
      )}
    </div>
  );
};

export default CardsStatistics;
